import styled from '@emotion/styled';
import { Typography } from '@mui/material';

export const Title = styled(Typography)`
  align: center;
  font-weight: 700;
  font-family: 'Source Serif Pro';
`;

export const Subtitle = styled(Typography)`
  color: white;
  align: center;
  margin-top: 10px;
`;
